import './styles.css';
import { renderDownload } from './download';
import { renderUpload } from './upload';

const app = document.getElementById('app');
if (app) {
  // Routing: `/d/:id` (or `?t=:id`) is the download view; everything else uploads.
  const match = /^\/d\/([^/]+)\/?$/.exec(location.pathname);
  const queryId = new URLSearchParams(location.search).get('t');
  if (match) {
    renderDownload(app, decodeURIComponent(match[1]));
  } else if (queryId) {
    renderDownload(app, queryId);
  } else {
    renderUpload(app);
  }
}
